<div
    class="agpr-actionAssistant"
    [agprLoading]="loading"
>
    <div class="agpr-actionAssistant-left agpr-actionAssistant-section" [id]="id + '_left_section'">
        <div class="agpr-actionAssistant-sectionHeading agpr-actionAssistant-sectionHeadingContainer">
            {{ "Reports.coverageInsight.source" | localize }}
        </div>
        <div class="agpr-actionAssistant-sourcePicker">
            <agpr-chart-drilldown-source-picker
                [id]="id + '_source_picker'"
                [(ngModel)]="drilldownSeries"
                (ngModelChange)="sourceChanged($event)"
            ></agpr-chart-drilldown-source-picker>
        </div>
        <div class="agpr-actionAssistant-dateRangeSelector">
            <label
                class="agpr-actionAssistant-dateRangeSelector-label"
                [id]="id + '_dateQuery'"
            >
                {{ 'Reports.coverageInsight.dateQuery.label' | localize}}
            </label>
            <agpr-date-query-popup
                [ariaLabelledBy]="id + '_dateQuery'"
                [options]="dateOptions"
                [(ngModel)]="dateQuery"
                [searchRange]="searchRange"
                (ngModelChange)="dateRangeChanged()"
            >
            </agpr-date-query-popup>
        </div>
        @if(mentionCount > errorMentionCount) {
            <div
                class="agpr-actionAssistant-mentionCountInfo"
            >
                <agpr-message
                    [severity]="messageSeverityEnum.error"
                >
                    {{ 'Reports.coverageInsight.mentionCountInfo.lessThanThreshold' | localize: {total: mentionCount} }}
                    <br>
                    {{ 'Reports.coverageInsight.mentionCountInfo.error' | localize }}
                </agpr-message>
            </div>
        } @else if (mentionCount > warningMentionCount) {
            <div
                class="agpr-actionAssistant-mentionCountInfo"
            >
                <agpr-message
                    [severity]="messageSeverityEnum.warning"
                >
                    {{ 'Reports.coverageInsight.mentionCountInfo.lessThanThreshold' | localize: {total: mentionCount} }}
                    <br>
                    {{ 'Reports.coverageInsight.mentionCountInfo.warning' | localize }}
                </agpr-message>
            </div>
        }
        @else {
            <div
                class="agpr-actionAssistant-mentionCountInfo"
            >
                <agpr-message
                    [severity]="messageSeverityEnum.info"
                >
                    {{ 'Reports.coverageInsight.mentionCountInfo.lessThanThreshold' | localize: {total: mentionCount} }}
                </agpr-message>
            </div>
        }
        @if(keyMessageGroups?.length) {
            <div
                class="agpr-actionAssistant-keyMessages"
            >
                <div class="agpr-actionAssistant-keyMessages-label">
                    {{ "Reports.coverageInsight.keyMessages" | localize }}
                </div>
                <agpr-scroll-panel
                    #keyMessageScrollPanel
                    [id]="id + '_keyMessages_scrollPanel'"
                >
                    <ul
                        [id]="id + '_keyMessages_list'"
                        class="agpr-actionAssistant-keyMessages-cardContainer"
                        agprListKeyboardNavigation
                        [list]="keyMessageGroups"
                    >
                        @for (keyMessageGroup of keyMessageGroups; track $index) {
                            <li
                                class="agpr-actionAssistant-keyMessages-card"
                                [ngClass]="{
                                    'agpr-actionAssistant-keyMessages-card--selected': keyMessageGroup.selected
                                }"
                                (click)="selectKeyMessage(keyMessageGroup)"
                                (keydown.enter)="selectKeyMessage(keyMessageGroup)"
                            >
                                <div class="agpr-actionAssistant-keyMessages-card-content">
                                    <div class="agpr-actionAssistant-keyMessages-card-title">{{ keyMessageGroup.keyMessageGroupTitle }}</div>
                                    <div class="agpr-actionAssistant-keyMessages-card-summary">{{ keyMessageGroup.keyMessageGroupSummary }}</div>
                                </div>
                            </li>
                        }
                    </ul>

                    @if(showBackButton) {
                            <div class="agpr-actionAssistant-keyMessages-backButton">
                                <agpr-button
                                    label="Reports.coverageInsight.backToAnalysis"
                                    (click)="backToAnalysis()"
                                    [style]="buttonTypes.tertiary"
                                ></agpr-button>
                            </div>
                        }
                </agpr-scroll-panel>
            </div>
        }
        @if (keyMessageGroups?.length) {
            <div
                class="agpr-actionAssistant-left-userDefinedKeyMessage"
                [@toggleContent]="{ value: collapsed ? 'collapsed' : 'expand', params: { height: '35px' } }"
                (@toggleContent.done)="onToggleDone()"
            >
                <div class="agpr-actionAssistant-userDefinedMessage">
                    <div
                        class="agpr-actionAssistant-userDefinedMessage-header"
                    >
                        {{ 'Reports.coverageInsight.userDefinedMessage.header' | localize }}
                    </div>
                    @if (!collapsed) {
                        <agpr-textarea-input
                            [id]="id + '_userDefinedMessage_textArea'"
                            label="Reports.coverageInsight.userDefinedMessage.description"
                            [rows]="4"
                            [placeholder]="'Reports.coverageInsight.userDefinedMessage.placeholder' | localize"
                            [(ngModel)]="userDefinedKeyMessageString"
                        ></agpr-textarea-input>
                        <div
                            class="agpr-actionAssistant-userDefinedMessage-buttonContainer"
                        >
                            <agpr-button
                                [id]="id + '_userDefinedMessage_applyButton'"
                                label="Reports.coverageInsight.userDefinedMessage.button"
                                [disabled]="!userDefinedKeyMessageString?.trim()"
                                [style]="buttonTypes.tertiary"
                                (click)="applyUserDefinedKeyMessage()"
                            ></agpr-button>
                        </div>
                    }
                    <span
                        class="fa-solid agpr-expandToggle agpr-actionAssistant-userDefinedMessage-expandToggle agpr-actionAssistant-userDefinedMessage-expandToggle--left"
                        [ngClass]="collapsed ? 'fa-angle-up' : 'fa-angle-down'"
                        [id]="id + '_userDefinedMessage_expandToggle'"
                        (click)="toggle($event)"
                    >
                    </span>
                </div>
            </div>
        }
    </div>
    @if (!keyMessageGroups?.length) {
        <div
            class="agpr-actionAssistant-section agpr-actionAssistant-dashboard"
        >
            <div class="agpr-actionAssistant-infoCard">
                <div class="agpr-actionAssistant-infoCard-icon">
                    <span
                        aria-hidden="true"
                        class="fa-kit-duotone fa-agpr-ai-action"
                    ></span>
                </div>
                <div
                    class="agpr-actionAssistant-infoCard-header"
                    [innerHTML]="'Reports.actionAssistant.promotion.heading' | localize "
                >
                </div>
                <div class="agpr-actionAssistant-infoCard-text">
                    {{ 'Reports.actionAssistant.promotion.text' | localize }}
                </div>
                <div class="agpr-actionAssistant-addContext-container">
                    <div class="agpr-actionAssistant-addContext-description">
                        {{ 'Monitor.MAD.coverageInsights.addContext.description' | localize }}
                    </div>
                    <agpr-textarea-input
                        class="agpr-actionAssistant-addContext-textareaInput"
                        [id]="'actionAssistant_addContext_textarea'"
                        placeholder="Monitor.MAD.coverageInsights.addContext.placeholder"
                        [(ngModel)]="analysisContext"
                        [rows]="5"
                        [icon]="'fa-kit-duotone fa-agpr-ai-generic'"
                    ></agpr-textarea-input>
                </div>
                <div class="agpr-actionAssistant-infoCard-button">
                    <agpr-button
                        label="Reports.coverageInsight.promotion.button"
                        id="drilldownAnalyzeCoverage"
                        (click)="analyzeCoverage($event)"
                        [style]="buttonTypes.primary"
                        [disabled]="mentionCount <= 0"
                        [tailIcon]="hasCoverageInsightsEnabled ? '' : 'fa-kit-duotone fa-agpr-upgrade'"
                    ></agpr-button>
                </div>
            </div>
            <div class="agpr-actionAssistant-spacer"></div>
            @if (hasCoverageInsightsEnabled) {
                <div
                    class="agpr-actionAssistant-userDefinedMessageContainer"
                    [@toggleContent]="collapsed ? 'collapsed' : 'expand'"
                    (@toggleContent.done)="onToggleDone()"
                >
                    <div class="agpr-actionAssistant-userDefinedMessage">
                        @if(collapsed) {
                            <div
                                class="agpr-actionAssistant-userDefinedMessage-info"
                            >
                                {{ 'Reports.coverageInsight.userDefinedMessage.info' | localize }}
                            </div>
                        }
                        <div
                            class="agpr-actionAssistant-userDefinedMessage-header"
                        >
                            {{ 'Reports.actionAssistant.userDefinedMessage.header' | localize }}
                        </div>

                        @if (!collapsed) {
                            <agpr-textarea-input
                                [id]="id + '_userDefinedMessage_textArea'"
                                label="Reports.coverageInsight.userDefinedMessage.label"
                                [rows]="4"
                                [placeholder]="'Reports.coverageInsight.userDefinedMessage.placeholder' | localize"
                                [(ngModel)]="userDefinedKeyMessageString"
                            ></agpr-textarea-input>
                            <div
                                class="agpr-actionAssistant-userDefinedMessage-buttonContainer"
                            >
                                <agpr-button
                                    [id]="id + '_userDefinedMessage_applyButton'"
                                    label="Reports.coverageInsight.userDefinedMessage.button"
                                    [style]="buttonTypes.tertiary"
                                    [disabled]="!userDefinedKeyMessageString?.trim()"
                                    (click)="applyUserDefinedKeyMessage()"
                                ></agpr-button>
                            </div>
                        }
                        <span
                            class="fa-solid agpr-expandToggle agpr-actionAssistant-userDefinedMessage-expandToggle"
                            [ngClass]="collapsed ? 'fa-angle-up' : 'fa-angle-down'"
                            (click)="toggle($event)"
                        >
                        </span>
                    </div>
                </div>
            }
        </div>
    } @else {
        <div
            class="agpr-actionAssistant-section agpr-actionAssistant-settings"
            [id]="id + '_settings_section'"
        >
            <agpr-scroll-panel
                #settingsScrollPanel
                [id]="id + '_settings_scrollPanel'"
            >
                <div class="agpr-actionAssistant-settings-scrollContainer">
                    <div class="agpr-actionAssistant-settings-description">
                        {{ "Reports.actionAssistant.settings.description" | localize }}
                    </div>
                    <form [formGroup]="settingsForm" class="agpr-actionAssistant-settings-fieldContainer">
                        <agpr-text-input
                            label="Reports.actionAssistant.settings.representation"
                            formControlName="representation"
                            placeholder="Reports.actionAssistant.settings.representation.placeholder"
                            tooltip="Reports.actionAssistant.settings.representation.tooltip"
                            [maxLength]="255"
                        >
                        </agpr-text-input>
                        <div class="agpr-actionAssistant-settings-positionField" #positionField>
                            <agpr-textarea-input
                                label="Reports.actionAssistant.settings.position"
                                formControlName="position"
                                placeholder="Reports.actionAssistant.settings.position.placeholder"
                                tooltip="Reports.actionAssistant.settings.position.tooltip"
                                [rows]="4"
                                [maxLength]="1000"
                            ></agpr-textarea-input>
                            <div class="agpr-actionAssistant-settings-positionField-aiButton" #aiButton (keydown.tab)="onAiButtonTab($event)">
                                <agpr-button
                                    [style]="buttonTypes.icon"
                                    [icon]="'fa-kit-duotone fa-agpr-ai'"
                                    tooltip="Reports.actionAssistant.settings.position.ai.tooltip"
                                    tooltipPosition="top"
                                    (click)="generatePositionSuggestions(aiButton)"
                                ></agpr-button>
                            </div>
                        </div>

                        <div class="agpr-actionAssistant-settings-contentSettings">
                            <div class="agpr-actionAssistant-settings-contentSettings-heading">
                                {{ "Reports.actionAssistant.settings.contentSettings" | localize }}
                            </div>
                            <div class="agpr-actionAssistant-settings-contentSettings-field" #contentTypeField>
                                <agpr-autocomplete
                                    [id]="id + '_contentType_autocomplete'"
                                    label="Reports.actionAssistant.settings.contentType"
                                    formControlName="contentType"
                                    placeholder="Reports.actionAssistant.settings.contentType.placeholder"
                                    labelField="label"
                                    [dropdown]="true"
                                    [forceSelection]="false"
                                    [clearOnBlur]="false"
                                    [sortSuggestions]="false"
                                    [required]="true"
                                    [suggestions]="contentTypeOptions$"
                                ></agpr-autocomplete>
                            </div>
                            <div class="agpr-actionAssistant-settings-contentSettings-field">
                                <agpr-autocomplete
                                    [id]="id + '_goal_autocomplete'"
                                    label="Reports.actionAssistant.settings.goal"
                                    formControlName="goal"
                                    placeholder="Reports.actionAssistant.settings.goal.placeholder"
                                    labelField="label"
                                    [dropdown]="true"
                                    [forceSelection]="false"
                                    [clearOnBlur]="false"
                                    [sortSuggestions]="false"
                                    [suggestions]="goalOptions$"
                                ></agpr-autocomplete>
                            </div>
                            <div class="agpr-actionAssistant-settings-contentSettings-field">
                                <agpr-autocomplete
                                    [id]="id + '_targetAudience_autocomplete'"
                                    label="Reports.actionAssistant.settings.targetAudience"
                                    formControlName="targetAudience"
                                    placeholder="Reports.actionAssistant.settings.targetAudience.placeholder"
                                    tooltipInfo="Reports.actionAssistant.settings.targetAudience.tooltip"
                                    labelField="label"
                                    [dropdown]="true"
                                    [forceSelection]="false"
                                    [clearOnBlur]="false"
                                    [sortSuggestions]="false"
                                    [suggestions]="targetAudienceOptions$"
                                ></agpr-autocomplete>
                            </div>
                            <div class="agpr-actionAssistant-settings-contentSettings-field">
                                <agpr-autocomplete
                                    [id]="id + '_tone_autocomplete'"
                                    label="Reports.actionAssistant.settings.tone"
                                    formControlName="tone"
                                    placeholder="Reports.actionAssistant.settings.tone.placeholder"
                                    tooltipInfo="Reports.actionAssistant.settings.tone.tooltip"
                                    labelField="label"
                                    [dropdown]="true"
                                    [forceSelection]="false"
                                    [clearOnBlur]="false"
                                    [sortSuggestions]="false"
                                    [suggestions]="toneOptions$"
                                ></agpr-autocomplete>
                            </div>
                            <div class="agpr-actionAssistant-settings-contentSettings-field">
                                <agpr-autocomplete
                                    [id]="id + '_language_autocomplete'"
                                    label="Reports.actionAssistant.settings.language"
                                    formControlName="language"
                                    placeholder="Reports.actionAssistant.settings.language.placeholder"
                                    labelField="label"
                                    [dropdown]="true"
                                    [forceSelection]="false"
                                    [clearOnBlur]="false"
                                    [sortSuggestions]="false"
                                    [suggestions]="languageOptions$"
                                ></agpr-autocomplete>
                            </div>
                        </div>
                    </form>
                </div>
            </agpr-scroll-panel>
            <div class="agpr-actionAssistant-settings-footer">
                <agpr-button
                    [id]="id + '_generate_button'"
                    [label]="hasGenerated ? 'Reports.actionAssistant.settings.regenerate' : 'Reports.actionAssistant.settings.generate'"
                    [style]="buttonTypes.tertiary"
                    [disabled]="isGenerateDisabled"
                    [tooltip]="generateDisabledTooltip"
                    tooltipPosition="top"
                    (click)="generateContent()"
                ></agpr-button>
            </div>
        </div>
    }


    @if (keyMessageGroups?.length) {
        <div
            class="agpr-actionAssistant-section agpr-actionAssistant-output"
            [class.agpr-actionAssistant-output--generated]="hasGenerated"
            [id]="id + '_output_section'"
        >
            <div class="agpr-actionAssistant-sectionHeading agpr-actionAssistant-sectionHeadingContainer">
                {{ "Reports.actionAssistant.contentOutput" | localize }}
            </div>

            @if (!hasGenerated) {
                <div class="agpr-actionAssistant-output-emptyState">
                    <span
                        aria-hidden="true"
                        class="fa-light fa-file-lines agpr-actionAssistant-output-emptyState-icon"
                    ></span>
                </div>
            } @else {
                <agpr-scroll-panel
                #contentScrollPanel
                [id]="id + '_prompt_scrollPanel'"
                >
                    <div class="agpr-actionAssistant-output-scrollContainer">
                        <div class="agpr-actionAssistant-output-contentTypeLabel">
                            {{ generatedContentTypeLabel }}
                        </div>

                        @if (generatedResponse) {
                            @if (isEmailOutput) {
                                <agpr-text-input
                                    [label]="'Reports.actionAssistant.output.subjectLine'"
                                    [(ngModel)]="generatedResponse.subjectLine"
                                ></agpr-text-input>
                                <agpr-text-input
                                    [label]="'Reports.actionAssistant.output.previewText'"
                                    [(ngModel)]="generatedResponse.previewText"
                                ></agpr-text-input>
                            }
                            @if (isHeadlineOutput) {
                                <agpr-text-input
                                    [label]="'Reports.actionAssistant.output.headline'"
                                    [(ngModel)]="generatedResponse.headline"
                                ></agpr-text-input>
                            }

                            <div class="agpr-actionAssistant-output-bodyLabel">
                                {{ 'Reports.actionAssistant.output.body' | localize }}
                            </div>
                            <agpr-rich-text-editor-ck
                                [richTextEditorConfig]="ckEditorConfig"
                                [(ngModel)]="generatedResponse.body"
                            ></agpr-rich-text-editor-ck>
                        }
                    </div>

                </agpr-scroll-panel>
                @if (hasGenerated) {
                    <div class="agpr-actionAssistant-output-footer">
                        <agpr-button
                            [id]="id + '_reset_button'"
                            label="Reports.actionAssistant.output.reset"
                            [style]="buttonTypes.tertiary"
                            (click)="resetOutput()"
                        ></agpr-button>
                        <div class="agpr-actionAssistant-output-footer-right">
                            <agpr-button
                                [id]="id + '_copyAll_button'"
                                label="Reports.actionAssistant.output.copyAll"
                                [style]="buttonTypes.tertiary"
                                (click)="copyAll()"
                            ></agpr-button>
                            @if (isCreateDistributionOutput) {
                                <agpr-button
                                    [id]="id + '_createDistribution_button'"
                                    label="Reports.actionAssistant.output.createDistribution"
                                    [style]="buttonTypes.tertiary"
                                    (click)="createDistribution()"
                                ></agpr-button>
                            }
                            <agpr-button
                                [id]="id + '_email_button'"
                                label="Reports.actionAssistant.output.email"
                                [style]="buttonTypes.tertiary"
                                (click)="openEmail()"
                            ></agpr-button>
                        </div>
                    </div>
                }
            }
        </div>
    }
    @if (loadingPositionSuggestions || positionSuggestions.length) {
        <div
            #positionSuggestionsPopup
            class="agpr-actionAssistant-settings-positionField-popup"
            tabindex="-1"
            [style.top.px]="positionSuggestionsTop"
            [style.left.px]="positionSuggestionsLeft"
            (clickOutside)="closePositionSuggestions()"
            (keydown.tab)="onPositionSuggestionsPopupTab($event)"
        >
            @if (loadingPositionSuggestions) {
                <div class="agpr-actionAssistant-settings-positionField-popup-loader" [agprLoading]="true"></div>
            } @else {
                <div class="agpr-actionAssistant-settings-positionField-popup-scrollContainer">
                    <agpr-scroll-panel [id]="id + '_positionSuggestions_scrollPanel'">
                        <ul
                            #positionSuggestionsList
                            [id]="id + '_positionSuggestions_list'"
                            class="agpr-actionAssistant-settings-positionField-popup-items"
                            agprListKeyboardNavigation
                            [list]="positionSuggestions"
                            (keydown.tab)="onPositionSuggestionsTab($event)"
                        >
                            @for (suggestion of positionSuggestions; track suggestion.positionId) {
                                <li
                                    class="agpr-actionAssistant-settings-positionField-popup-item"
                                    (click)="selectPositionSuggestion(suggestion)"
                                    (keydown.enter)="selectPositionSuggestion(suggestion)"
                                >
                                    {{ suggestion.position }}
                                </li>
                            }
                        </ul>
                    </agpr-scroll-panel>
                </div>
            }
        </div>
    }
</div>
